module.exports = __webpack_public_path__ + "static/media/amazaon.f1fc2cd7.png";